import axios, { AxiosInstance } from 'axios'
import Config from '@/config/default/config'
import * as Sentry from '@sentry/browser'

import { URLs } from '@it/orpk-vue-ts'

const scienceURLs = URLs.science

export const baseURL =
  process.env.NODE_ENV === 'production'
    ? scienceURLs.production.serverURL
    : scienceURLs.local.serverURL

export const clientBase =
  process.env.NODE_ENV === 'production'
    ? scienceURLs.production.clientURL
    : scienceURLs.local.clientURL

export const clientStaticBase =
  process.env.NODE_ENV === 'production'
    ? `${clientBase}/api`
    : `${clientBase}/science/api`

export const socketPath = scienceURLs.production.socketPath
export const socketURL = scienceURLs.production.socketURL

export const http: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true
})

function processSentry(error: any) {
  Sentry.withScope(scope => {
    if (error?.response) {
      scope.addBreadcrumb({
        category: 'response-data',
        message: JSON.stringify(error.response.data, null, 4)
      })
      scope.addBreadcrumb({
        category: 'status',
        message: error.response.status
      })
    }
    if (error?.config) {
      const scopeUrl = error.config.url?.replace(/[0-9]+/g, 'X') ?? ''
      const method = error.config.method
      const status = error.response?.status ?? '{no status}'
      error.message = `AxiosError ${status} ${method} ${scopeUrl}`
      scope.addBreadcrumb({
        category: 'request-data',
        message: error.config.data
      })
      scope.addBreadcrumb({
        category: 'path',
        message: error.config.url
      })
      scope.addBreadcrumb({
        category: 'method',
        message: error.config.method
      })
      scope.addBreadcrumb({
        category: 'scope',
        message: scopeUrl
      })
      scope.setFingerprint([
        error.config.method,
        scopeUrl,
        String(error.response?.status ?? 500)
      ])
    }
    if (error.response && error.response.status >= 401) {
      Sentry.captureException(error)
    } else {
      error.message = (error.message ?? '') + '[IGNORE]'
    }
  })
}

http.interceptors.request.use(config => {
  if (!Config.urlsWithoutInterceptors.includes(config.url!)) {
    const store = require('@/store').default
    store.commit('loading/enqueue', null, { root: true })
  }
  return config
})

http.interceptors.response.use(
  response => {
    if (!Config.urlsWithoutInterceptors.includes(response.config.url!)) {
      const store = require('@/store').default
      store.commit('loading/dequeue', null, { root: true })
    }
    return response
  },
  error => {
    processSentry(error)
    if (
      error.config &&
      !Config.urlsWithoutInterceptors.includes(error.config.url!)
    ) {
      const store = require('@/store').default
      store.commit('loading/dequeue', null, { root: true })
      let data: any
      if (error.response?.data.constructor === ArrayBuffer) {
        try {
          data = JSON.parse(new TextDecoder().decode(error.response.data))
        } catch {
          data = {}
        }
      } else {
        data = error.response?.data ?? {}
      }
      console.error(error.response)
      store.dispatch('toast/pushToast', {
        error: true,
        title: 'Ошибка',
        message: data?.message || `Ошибка ${error.response?.code ?? ''}`
      })
    }
    throw error
  }
)
